module.exports = __webpack_public_path__ + "static/media/Subtract.542b1390.svg";